import ClientsAxios from '../../client-axios';
import { ResponseEntity } from '../../dto/response';

const { API_SERVER } = ClientsAxios;


export const StoreCollaborationAgreementService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('project/tri-party-mou-project/store', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const FetchCollaborationAgreementListService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('project/tri-party-mou-project/list', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}


export const GetCollaborationAgreementDetailService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('project/tri-party-mou-project/details', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}

export const FetchMouAgreementBeneficiaryListService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>();
    try {
        const response = await API_SERVER.post('project/beneficiaries/list', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response ?? {};
        responseEntity.error(response?.StatusCode ?? 500, error?.Message, response?.data?.body ?? {})
    }
    return responseEntity
}

export const FetchMouAgreementBeneficiarySummaryService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>();
    try {
        const response = await API_SERVER.post('project/beneficiaries/summary', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response ?? {};
        responseEntity.error(response?.StatusCode ?? 500, error?.Message, response?.data?.body ?? {})
    }
    return responseEntity
}

export const StoreUpdateNMouAgreementBeneficiaryService = async (payload: any, isUpdate: boolean) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post(isUpdate ? 'project/beneficiaries/update' : 'project/beneficiaries/create', payload, { headers: { 'Content-Type': 'multipart/form-data' } })
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response ?? {};
        responseEntity.error(response?.StatusCode ?? 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const FetchMouAgreementActivityLogJourneyService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('tri-party-mou-agreement/activity-logs', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const FetchProjectBeneficiaryActivityLogJourneyService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('project/tri-party-mou-project/activity-logs', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}
export const GetCollabrationAgreementBeneficiariesDetailsService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('project/beneficiaries/details', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const DownloadBeneficiaryDocumentsZipService = async (payload: { uuid: string }) => {
    const responseEntity = new ResponseEntity<Blob>()
    try {
        const response = await API_SERVER.post('project/beneficiaries/download-docs-zip', payload, { responseType: 'blob' })
        responseEntity.success(response.data as Blob, 200, '')
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const VerifyBeneficiaryDocService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('project/beneficiaries/verify-docs', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const UpdateProjectBeneficiaryStatusService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('project/beneficiaries/status-update', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const StoreBeneficiaryDisbursmentService = async (payload: FormData) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('project/beneficiaries/store-disbursment', payload, { headers: { 'Content-Type': 'multipart/form-data' } })
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const ListBeneficiaryDisbursmentService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('project/beneficiaries/list-disbursment', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const StoreBeneficiaryUtilizationService = async (payload: FormData) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('project/beneficiaries/store-utilization', payload, { headers: { 'Content-Type': 'multipart/form-data' } })
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const ListBeneficiaryUtilizationService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('project/beneficiaries/list-utilization', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const FetchBeneficiariesUtilizeCountService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('project/beneficiaries/utilize-count', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const FetchBeneficiaryCountService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('project/beneficiaries/count', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const FetchPatientApplicationDetailService = async (uid_token: string) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('patient-application/detail', { uid_token})
        responseEntity.success(response.data.body?.result, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const ListBeneficiaryCommentsService = async (payload: { beneficiary_uuid: string; limit?: number; offset?: number; }) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('beneficiaries/comment-list', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const StoreBeneficiaryCommentService = async (payload: FormData) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('beneficiaries/comment-store', payload, { headers: { 'Content-Type': 'multipart/form-data' } })
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const UpdateBeneficiaryCommentService = async (payload: FormData) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('beneficiaries/comment-update', payload, { headers: { 'Content-Type': 'multipart/form-data' } })
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const DeleteBeneficiaryCommentService = async (payload: { uuid: string }) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('beneficiaries/comment-delete', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}
